export default __webpack_public_path__ + "static/media/2d97d48e-68ae-4d98-bbb9-b8d13b54cc64 2.be8577c1.JPG";